import { render, staticRenderFns } from "./Lms.vue?vue&type=template&id=4ab7fe40&scoped=true&"
import script from "./Lms.vue?vue&type=script&lang=ts&"
export * from "./Lms.vue?vue&type=script&lang=ts&"
import style0 from "./Lms.vue?vue&type=style&index=0&id=4ab7fe40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab7fe40",
  null
  
)

export default component.exports